import React from "react";
import { Col, Row } from "antd";
import Input from "../../../common/forms/fields/Input";

interface Props {
  name: string[];
  title: string;
}

const fields = {
  consignor: "consignor",
  currency1: "currency1",
  currency2: "currency2",
  consignee: "consignee",
};

const CarriagePaymentRow: React.FC<Props> = ({ name, title }) => (
  <Row>
    <Col span={6}>{title}</Col>
    <Col span={6}>
      <Input
        name={[...name, fields.consignor]}
        config={{ placeholder: `Enter ${fields.consignor}` }}
      />
    </Col>
    <Col span={3}>
      <Input
        name={[...name, fields.currency1]}
        config={{ placeholder: "Enter currency" }}
      />
    </Col>
    <Col span={3}>
      <Input
        name={[...name, fields.currency2]}
        config={{ placeholder: `Enter currency` }}
      />
    </Col>
    <Col span={6}>
      <Input
        name={[...name, fields.consignee]}
        config={{ placeholder: `Enter ${fields.consignee}` }}
      />
    </Col>
  </Row>
);

export default CarriagePaymentRow;
